export enum TemplatesTypes {
  Classic = "classic",
  Corporate = "corporate",
}

export type PageSizeType = "A4" | "A5" | "A3" | "80mm";

export type PageOrientation = "portrait" | "landscape";

export interface PageSizeConfig {
  width: string;
  height: string;
  orientation: PageOrientation;
}

export interface InvoiceTemplateContext {
  order: any;
  config: {
    store_name: string;
    address: string;
    phone: string;
    currency: string;
    receipt_footer: string;
    [key: string]: any;
  };
  pageSize: PageSizeType;
  orientation?: PageOrientation;
  isForPrint: boolean;
  fmt: (val: any) => string;
}
